import { modalResponse } from '@ispm/layout/constants/modal-responses.enum';
import { Subject, Observable } from 'rxjs';
import { EmitterTypes } from '../constants/emitter-types.enum';
import {Component, OnInit} from '@angular/core';
import { EmitType } from '../constants/emit-types.enum';
import { catchError } from 'rxjs/operators';

@Component({
    template: ''
})
export abstract class PlaceholderChildComponent<PayloadType = any, ResponsePayloadType = any> implements OnInit {
  public payload: PayloadType;
  public tunnel$: Subject<{ emitter?: EmitterTypes, value: number, payload?: ResponsePayloadType}>;
  public callback: (...args) => void;

  constructor() {
  }

  /**
   * must be implemented as super.ngOnInit() on child ngOnInit
   */
  ngOnInit() {
    if (!this.tunnel$) {
      return;
    }

    this.tunnel$
      .asObservable()
      .filter(message => message.emitter !== EmitterTypes.child && message.value !== EmitType.Data)
      .map(message => message.value)
      .flatMap((_modalResponse: modalResponse) => {
        const componentResponse = this.beforeClose(_modalResponse);

        if (_modalResponse !== modalResponse.approve) {
          return Observable.of(componentResponse);
        }

        if (!(componentResponse instanceof Promise || componentResponse instanceof Observable)) {
          return Observable.of(componentResponse);
        }
        else if (componentResponse instanceof Promise) {
          componentResponse.catch(err => {
            console.error(err);
            return { isValid: false};
          });
        }
        else if (componentResponse instanceof Observable) {
          componentResponse.pipe(
            catchError(err => {
              console.error(err);

              return Observable.of({ isValid: false});
            })
          );
        }

        return componentResponse as Observable<any>;
      })
      .filter(componentResponse => !componentResponse || componentResponse.isValid !== false)
      .subscribe(data => {
        this.tunnel$.next({ emitter: EmitterTypes.child, value: EmitType.Dismiss, payload: data});
      });
  }

  /**
   * function to run before the modal close, usually used to call the callback function with the needed data from the modal
   */
  abstract beforeClose(_modalResponse?: modalResponse): void | ICloseReturnType;
}

export type ICloseReturnType = Promise<ICloseReturnObject> | Observable<ICloseReturnObject> | ICloseReturnObject;
export type ICloseReturnObject = { isValid: boolean} & any;
